import {Route} from "react-router-dom";
import CrewInventoryPage from "./pages/CrewInventoryPage";
import CrewInventoryOtpLogin from "./pages/CrewInventoryOtpLogin";

const InventoryCrewRoutes = () => {
    return (
        <>
        <Route path="/crew-inventory/*" element={<CrewInventoryOtpLogin />} />
        <Route path="/inventory-dashboard" element={<CrewInventoryPage />} />
        </>
    )
}

export default InventoryCrewRoutes;